import { useAxios } from '@/plugins/axios';
import { useCacheRequisicoesStore } from '@/stores/cacheRequisicoes';

/**
 * Prefixo das chaves de cache de tudo que a tela inicial exibe. O botão
 * "Atualizar" invalida por este prefixo, então qualquer endpoint consumido por
 * um painel deve ser buscado com ele — inclusive os que vêm de composables
 * compartilhados com outras telas.
 */
export const PREFIXO_CACHE_DASHBOARD = 'dashboard:';

/**
 * Busca GET passando pelo cache com expiração de `src/stores/cacheRequisicoes`.
 *
 * A chave é o prefixo + a URL completa (com os parâmetros), então cada recorte
 * — ano, página, filtro — é cacheado separadamente.
 *
 * Precisa ser chamado no `setup`, porque depende do axios injetado.
 *
 * @param {string} [prefixo] - Escopo das chaves, para invalidação em bloco
 */
export function useCacheApi(prefixo = '') {
    const axios = useAxios();
    const cacheRequisicoes = useCacheRequisicoesStore();

    /**
     * GET direto, sem passar pelo cache.
     * @param {string} url
     * @returns {Promise<*>} corpo da resposta
     */
    const buscar = async (url) => (await axios.get(url)).data;

    /**
     * @param {string} url
     * @param {object} [opcoes] - `{ forcar, ttlMinutos }`
     * @returns {Promise<*>} corpo da resposta
     */
    const buscarComCache = (url, opcoes) =>
        cacheRequisicoes.obterOuBuscar(`${prefixo}${url}`, () => buscar(url), opcoes);

    return { buscar, buscarComCache };
}
